<template>
  <div class="container-newcards">
    <div class="wrapper-title pdb-4">
      <div class="wrapper-left">
        <h4 class="tit-h6 title-ellipsis">
          {{
            t('self_service_payment_details_title', {
              userName: adminStore.getPartnerEmployeeInfo.nickname,
            })
          }}
        </h4>
        <div class="primary-bg pc-badge">{{ subscriptionStore.userPlan }}</div>
      </div>

      <div class="wrapper-right">
        <button type="button" class="round-b-btn line-btn" @click="togglePaymentModal">
          {{ t('self_service_open_purchase_history') }}
        </button>

        <button type="button" class="round-b-btn line-btn" @click="goToPlanInfo">
          {{ t('explore_subscription') }}
        </button>
      </div>
    </div>

    <div class="wrapper-newcards">
      <PaymentSettingsDetailCardOverview />
      <PaymentSettingsDetailCardBenefits />
    </div>
  </div>

  <Teleport to="body">
    <SelfServicePaymentModal v-if="showPaymentModal" menu="PAYMENT" @close="togglePaymentModal" />
  </Teleport>
</template>

<script setup lang="ts">
import PaymentSettingsDetailCardBenefits from '@/components/domains/self-service/payment-settings/PaymentSettingsDetailCardBenefits.vue';
import PaymentSettingsDetailCardOverview from '@/components/domains/self-service/payment-settings/PaymentSettingsDetailCardOverview.vue';
import SelfServicePaymentModal from '@/components/domains/self-service/SelfServicePaymentModal.vue';
import { useGtag } from '@/composables/shared/useGtag';
import { useAdminStore } from '@/stores/admin';
import { usePaymentStore } from '@/stores/payment';
import { useSubscriptionStore } from '@/stores/subscription';

const { t } = useI18n();
const router = useRouter();

const adminStore = useAdminStore();
const paymentStore = usePaymentStore();
const subscriptionStore = useSubscriptionStore();

const { trackEventClick } = useGtag();

const showPaymentModal = ref<boolean>(false);

const goToPlanInfo = () => {
  trackEventClick('plan_manage', '구독 알아보기');
  router.push({ name: 'ss-plan-info' });
};

const togglePaymentModal = () => {
  showPaymentModal.value = !showPaymentModal.value;
};

onMounted(async () => {
  await paymentStore.fetchUserCardList();
});
</script>

<style scoped lang="scss">
.container-newcards {
  width: 100%;
}

.wrapper-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: center;
  width: 100%;

  .wrapper-left {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    min-width: 0;
  }

  .title-ellipsis {
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .wrapper-right {
    display: flex;
    gap: 0.5rem;

    @include respond-to(mobile-landscape) {
      width: 100%;
    }
  }
}

.wrapper-newcards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  align-items: stretch;
  @include respond-to(tablet) {
    grid-template-columns: repeat(1, 1fr);
  }

  @include respond-to(mobile-landscape) {
    display: flex;
    flex-direction: column;
  }
}

.icon-small {
  margin-right: 0.5rem;
}

::v-deep(.wrapper-detail) {
  display: grid;
  grid-template-columns: 1fr auto;
  row-gap: 0.5rem;
  column-gap: 1rem;

  dt {
  }

  dd {
    text-align: right;
    justify-self: end;
    font-weight: 600;
  }

  @include respond-to(mobile-portrait) {
    dt {
      font-size: $font-size-psmall;
    }
  }
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  li {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
}

.container-paymentdetailcard {
  display: flex;
  flex-direction: column;
  min-height: 400px;
  height: 100%;
  border: 1px solid $color-gray-40;
  border-radius: 20px;
  padding: 2.5rem;
}

@include respond-to(mobile-landscape) {
  .container-paymentdetailcard {
    padding: 1.25rem;
  }
  :deep(.card-title) {
    font-size: 1.25rem;
  }
}
</style>
